import Immutable from 'seamless-immutable';
// ---- external imports ----

import GameService from '~/services/game.service';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	systemLogsByDate: {},
	logsByDate: {},
	isLogbookAutomatedByDate: {},
	isLoaded: false
});

function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.LOGBOOK_LOADED:
		return state.merge({
			logsByDate: action.logbook,
			systemLogsByDate: action.systemLogbook,
			isLogbookAutomatedByDate: action.isLogbookAutomatedByDate,
			isLoaded: true
		});
	case types.LOGBOOK_FETCH_UPDATED_BY_BOOKKEEPER:
		return state.merge({
			logsByDate: action.logbook,
			isLoaded: true
		});
	case types.LOGBOOK_FETCH_UPDATED_BY_SYSTEM:
		return state.merge({
			systemLogsByDate: action.systemLogbook,
			isLogbookAutomatedByDate: action.isLogbookAutomatedByDate,
			isLoaded: true
		});
	case types.LOGBOOK_UPDATE_SALESLOG_FOR_DATE:
		return getUpdatedStateAfterSalesLogUpdate(state, action);
	case types.LOGBOOK_UPDATE_PURCHASES_LOG_FOR_DATE:
		return getUpdatedStateAfterPurchasesLogUpdate(state, action);
	case types.LOGBOOK_UPDATE_GENERAL_LOG_FOR_DATE:
		return getUpdatedStateAfterGeneralLogUpdate(state, action);
	default:
		return state;
	}
}

function getUpdatedStateAfterSalesLogUpdate(state, action) {
	const updatedState = state.merge(
		{
			logsByDate: {
				[action.date]: {
					sales: action.newSalesLog
				}
			}
		}, { deep: true });

	GameService.saveLogbook(action.gameUserId, updatedState.logsByDate);

	return updatedState;
}

function getUpdatedStateAfterPurchasesLogUpdate(state, action) {
	const updatedState = state.merge(
		{
			logsByDate: {
				[action.date]: {
					purchases: action.newPurchasesLog
				}
			}
		}, { deep: true });
	GameService.saveLogbook(action.gameUserId, updatedState.logsByDate);

	return updatedState;
}

function getUpdatedStateAfterGeneralLogUpdate(state, action) {
	const updatedState = state.setIn(
		['logsByDate', action.date, 'general'],
		action.newGeneralLog
	);

	GameService.saveLogbook(action.gameUserId, updatedState.logsByDate);

	return updatedState;
}

export default reduce;
